"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTable2 = void 0;
var react_1 = __importDefault(require("react"));
var react_table_1 = require("react-table");
var Table_1 = __importDefault(require("react-bootstrap/Table"));
// I couldn't think of a clean way to do this
var rowHeaderStyle = {
    padding: '0rem 2rem',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: '4.5rem',
    minWidth: '4.5rem',
    // position: 'sticky',
    // left: 0,
};
var AcTable2 = function (props) {
    var data = props.data, columns = props.columns, defaultColumn = props.defaultColumn, onUpdateCellValue = props.onUpdateCellValue, onFocusCell = props.onFocusCell, onBlurCell = props.onBlurCell, tableStyle = props.tableStyle, tableClass = props.tableClass, tableHeaderStyle = props.tableHeaderStyle, tableDataStyle = props.tableDataStyle, rowHeader = props.rowHeader, enableRowSelector = props.enableRowSelector;
    var _a = react_table_1.useTable({
        // @ts-ignore
        onUpdateCellValue: onUpdateCellValue,
        // @ts-ignore
        onFocusCell: onFocusCell,
        // @ts-ignore
        onBlurCell: onBlurCell,
        defaultColumn: defaultColumn,
        columns: columns,
        data: data,
        useRowSelect: enableRowSelector ? react_table_1.useRowSelect : undefined,
    }), getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, rows = _a.rows, prepareRow = _a.prepareRow;
    return (react_1.default.createElement(Table_1.default, __assign({ className: tableClass + " " }, getTableProps(), { style: __assign(__assign({}, tableStyle), { backgroundColor: 'white' }) }),
        react_1.default.createElement("thead", null, headerGroups.map(function (headerGroup) {
            var _a;
            return (react_1.default.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()),
                rowHeader && (react_1.default.createElement("th", __assign({}, (_a = headerGroup.headers[0]) === null || _a === void 0 ? void 0 : _a.getHeaderProps(), { style: __assign(__assign({}, rowHeaderStyle), tableHeaderStyle) }))),
                headerGroup.headers.map(function (column) { return (react_1.default.createElement("th", __assign({}, column.getHeaderProps(), { style: __assign({}, tableHeaderStyle) }), column.render('Header'))); })));
        })),
        react_1.default.createElement("tbody", __assign({}, getTableBodyProps()), rows.map(function (row, index) {
            var _a;
            prepareRow(row);
            return (react_1.default.createElement("tr", __assign({}, row.getRowProps()),
                rowHeader && (react_1.default.createElement("td", __assign({}, (_a = row.cells[0]) === null || _a === void 0 ? void 0 : _a.getCellProps(), { style: __assign(__assign({}, tableHeaderStyle), rowHeaderStyle) }), index + 1)),
                row.cells.map(function (cell) {
                    return (react_1.default.createElement("td", __assign({}, cell.getCellProps(), { className: "p-0", style: __assign({}, tableDataStyle) }), cell.render('Cell')));
                })));
        }))));
};
exports.AcTable2 = AcTable2;
exports.AcTable2.displayName = 'AcTable2';
//# sourceMappingURL=AcTable2.js.map